<!--  -->
<template>
<div class=''>
   <div class="table-img" :style="'height:' + tableImgHeight + ''" :id="viewerId">
       <iframe  ref="myIframe" :src="baseServer"  style="width:100%;height: 100%;border: solid 0px;" :allowfullscreen="showphotespheremarker"/>
  </div>
</div>
</template>

<script>
import { mapResourceApi } from '@/api/mapResourceApi'

export default {
// import引入的组件需要注入到对象中才能使用

  components: {},
  props: {
    showphotespheremarker: {
      type: Boolean,
      default: true
    },
    landinfo: {
      type: Object
    },
    navbarStatusArray: {
      type: Array,
      default: () => []
    },
    tableImgHeight: {type: String, default: '197px'}
  },
  data() {
    // 这里存放数据
    return {
      baseServer: '',
      iframeUrl: '',
      viewerId: 'viewDiv_' + Math.ceil(Math.random() * 10000),
      myViewer: '',
      initView: false,
      iframeWin: {}
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {
    landinfo: {
      handler(newValue, oldValue) {
        setTimeout(() => {
          if (newValue !== '') {
            this.initPhotosphereviewer(newValue)
          }
        }, 600)
      },
      immediate: true,
      deep: true
    }
  },
  // 方法集合
  methods: {
    handleMessage(data) {
      //
    },
    initPhotosphereviewer(landinfo) {
      if (landinfo.qjt && landinfo.qjt !== '') {
        // 处理全景图缩略图
        const compress = `${loadCompressImg}`
        debugger
        console.log(compress)
        if (compress === 'true') {
          console.log(1)
          const qjt = landinfo.qjt
          const index = qjt.lastIndexOf('/')
          const path = qjt.substring(0, index)
          const filename = qjt.substring(index, qjt.length)
          const qjtthumbnail = path + '/compress' + filename
          landinfo.qjtthumbnail = qjtthumbnail
          const anorama = `${gisserverUrl}` + landinfo.qjtthumbnail
          landinfo.anorama = anorama
        } else {
          const anorama = `${gisserverUrl}` + landinfo.qjt
          landinfo.anorama = anorama
        }

        if (this.showphotespheremarker) {
          const param = {}
          param.id = landinfo.id
          mapResourceApi.getPhotoSphereMarkerListById(param).then(res => {
            if (res.code === 'B0001') {
              this.$utils.error('获取数据失败' + res.msg)
            } else if (res.code === '200') {
              landinfo.photespheremarkerlist = res.data
              this.iframeWin.postMessage(landinfo, '*')
            }
          })
        } else {
          landinfo.photespheremarkerlist = []
          this.iframeWin.postMessage(landinfo, '*')
        }
      }
    },
    initPhotosphereviewer1232(landinfo) {
      if (this.markersPlugin) {
        this.markersPlugin.clearMarkers()
      }
      if (landinfo.qjt && landinfo.qjt !== '') {
        if (this.markersPlugin) {
          this.markersPlugin.clearMarkers()
        }

        if (this.initView === false) {
          if (this.navbarStatusArray.length === 0) {
            this.myViewer = photosphereviewer.initPhotoViewer(this.viewerId, false)
          } else {
            this.myViewer = photosphereviewer.initPhotoViewer(this.viewerId, this.navbarStatusArray)
          }

          // 设置全景图照片，定位中心点
          photosphereviewer.setPhotoViewerPanorama(this.myViewer, anorama, landinfo.qjtzxd)
          this.myViewer.on('ready', map => {
            // 设置全景图 地块红线
            const markersPlugin = photosphereviewer.getMarkersPlugin(this.myViewer)
            this.markersPlugin = markersPlugin
            photosphereviewer.addPolygonRad(markersPlugin, landinfo.dkmc, landinfo.qjtzb, landinfo.qjtzxd)
            if (landinfo.photespheremarkerlist && this.showphotespheremarker) {
              photosphereviewer.addPhotoSphereMarker(markersPlugin, landinfo.photespheremarkerlist)
            }
          })
          this.initView = true
          this.myViewer.on('click', (e, data) => {
            if (!data.rightclick) {
              if (landinfo.plot && landinfo.plot === true) {
                // console.log(data.longitude + ',' + data.latitude)
                this.$emit('plotMarkerEvent', data.longitude + ',' + data.latitude)
                this.markersPlugin.addMarker(photosphereviewer.getPoiMarker('', data.longitude + ',' + data.latitude))
              }
            }
          })
        } else {
          photosphereviewer.setPhotoViewerPanorama(this.myViewer, anorama, landinfo.qjtzxd)
          // 设置全景图 地块红线,绘制周边标注
          const markersPlugin = photosphereviewer.getMarkersPlugin(this.myViewer)
          photosphereviewer.addPolygonRad(markersPlugin, landinfo.dkmc, landinfo.qjtzb, landinfo.qjtzxd)
          this.markersPlugin = markersPlugin
          this.myViewer.on('click', (e, data) => {
            if (!data.rightclick) {
              if (landinfo.plot && landinfo.plot === true) {
                this.$emit('plotMarkerEvent', data.longitude + ',' + data.latitude)
                this.markersPlugin.addMarker(photosphereviewer.getPoiMarker('', data.longitude + ',' + data.latitude))
              }
            }
          })
          if (landinfo.photespheremarkerlist && this.showphotespheremarker) {
            photosphereviewer.addPhotoSphereMarker(markersPlugin, landinfo.photespheremarkerlist)
          }
        }
      } else {
        if (this.myViewer) {
          this.myViewer_proto.destroy()
        }
      }
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.baseServer = `${photosphereviewerUrl}` + '/photosphereviewer/'
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    //
    this.iframeWin = this.$refs.myIframe.contentWindow
    window.addEventListener('message', this.handleMessage) // 监听iframe的事件
  }
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
 .table-img{
    /*height: 197px;*/
    width: 100%;
    img{
        width: 100%;
        height: 100%;
    }
}
</style>
